import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { LoadToeTemplates, ToeTemplateDataSource, ToeTemplateModel, ToeTemplateState } from 'src/app/core/template';
import { PaginationEvent } from '../../../template/template-list/template-list.component';

@Component({
  selector: 'kt-toe-template-list-modal',
  templateUrl: './toe-template-list-modal.component.html',
  styleUrls: ['./toe-template-list-modal.component.scss']
})
export class ToeTemplateListModalComponent implements OnInit {
  dataSource: ToeTemplateDataSource;
  pageSize = 4;

  constructor(
    public dialogRef: MatDialogRef<ToeTemplateListModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<ToeTemplateState>
  ) { }

  ngOnInit(): void {
    this.dataSource = new ToeTemplateDataSource(this.store);
    this.store.dispatch(new LoadToeTemplates({
      request: {
        pageNumber: 1,
        pageSize: this.pageSize,
        agencyID: this.data.agencyID
      }
    }));
  }

  loadList(event: PaginationEvent) {
    this.store.dispatch(new LoadToeTemplates({
      request: {
        pageNumber: event.pageNumber + 1,
        pageSize: event.pageSize,
        agencyID: this.data.agencyID
      }
    }));
  }

  selectTemplate(event: ToeTemplateModel) {
    this.dialogRef.close({
      type: 'select',
      template: event
    });
  }
  viewTemplate(event: ToeTemplateModel) {
    this.dialogRef.close({
      type: 'view',
      template: event
    });
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
